import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import * as SecureStore from 'expo-secure-store';
import {apiURI, mainSite} from '../config.js';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Bugsnag from '@bugsnag/expo';

/** STATE OBJECT */
const initialState = {
    userId: 0,
    wpAuthorizationToken: '',
    apiAuthToken: '',
    userType: '',
    authLoading: 'idle', // other values are pending, succeeded and failed
    authResultMessage: '',
    authStatus: 'idle',
    authStepStatus: 'pending',
};

/** ASYNC ACTIONS */
export const loginUser = createAsyncThunk(
    'cbcAuthorization/loginUser',
    async ({username, password}, {rejectWithValue}) => {
        console.log('loginUser has been dispatched');
        Bugsnag.leaveBreadcrumb('Action loginUser dispatched');
        const postData = {username: username, password: password};
        console.log('Post Data', postData);
        const response = await fetch(`${mainSite}/wp-json/jwt-auth/v1/token`, {
            method: 'POST',
            redirect: 'follow',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify(postData),
        });

        const results = await response.json();
        console.log('Auth Results', results);

        // did we get a successful response
        if (response.ok) {
            // verfiy a successful authorization
            if (undefined === results.token) {
                console.log('Login Failed.');
                return rejectWithValue(results.message);
            }
            // save the username and password
            await SecureStore.setItemAsync('username', username);
            await SecureStore.setItemAsync('password', password);
            return results;
        } else {
            // return the status text from the response
            Bugsnag.notify(
                'Api Error, wp-json/jwt-auth/v1/token: ' + results.message
            );
            return rejectWithValue(results.message);
        }
    }
);

export const createApiAuthToken = createAsyncThunk(
    'cbcAuthorization/createApiAuthToken',
    async ({userId, jwtAuthToken}, {rejectWithValue}) => {
        Bugsnag.leaveBreadcrumb('Action createApiAuthToken dispatched');
        const postData = {user_id: userId};
        ////console.log('Post Data', postData);
        const response = await fetch(
            `${apiURI}/app-specific/create-ajax-auth.php`,
            {
                method: 'POST',
                redirect: 'follow',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${jwtAuthToken}`,
                },
                body: JSON.stringify(postData),
            }
        );

        const results = await response.json();
        ////console.log('Auth Results', results);

        // did we get a successful response
        if (response.ok) {
            // verfiy a successful authorization
            if (!results.success) {
                return rejectWithValue(results.message);
            }

            return results;
        } else {
            // return the status text from the response
            Bugsnag.notify('Api Error, create-ajax-auth: ' + response.text());
            return rejectWithValue(response.text());
        }
    }
);

export const verifyUserIsLoggedIn = createAsyncThunk(
    'cbcAuthorization/verifyUserIsLoggedIn',
    async ({}, {rejectWithValue}) => {
        Bugsnag.leaveBreadcrumb('Action verifyUserIsLoggedIn dispatched');
        ////console.log('Verifying User Is Logged In');
        // call the endpoint to verify that the current user is logged in
        const response = await fetch(`${apiURI}/verify-user-logged-in.php`, {
            method: 'GET',
            redirect: 'follow',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
        });
        const results = await response.json();

        // did we get a successful response
        if (response.ok) {
            ////console.log(response);
            // verfiy a successful authorization
            if (!results.success) {
                return rejectWithValue(results.message);
            }

            return results;
        } else {
            // return the status text from the response
            Bugsnag.notify('Api Error, verify-user-logged-in: ' + response.text());
            return rejectWithValue(response.text());
        }
    }
);

export const logoutUser = createAsyncThunk(
    'cbcAuthorization/logoutUser',
    async () => {
        Bugsnag.leaveBreadcrumb('Action logoutUser dispatched');
        // Remove stored credentials
        await SecureStore.deleteItemAsync('username');
        await SecureStore.deleteItemAsync('password');
        await SecureStore.deleteItemAsync('apiAuthToken');
        await SecureStore.deleteItemAsync('authCode');
        await AsyncStorage.removeItem('userId');
    }
);

export const checkCurrentSessionTokenValid = createAsyncThunk(
    'cbcAuthorization/checkCurrentSessionTokenValid',
    async ({sessionToken, jwtAuthToken, userId}, {rejectWithValue}) => {
        Bugsnag.leaveBreadcrumb('Action checkCurrentSessionTokenValid dispatched');
        console.log('Verifying Access Token');
        //alert(userId);
        const postData = {session_token: sessionToken, user_id: userId};
        console.log('postData', postData);
        // call the endpoint to verify that the current user is logged in
        const response = await fetch(
            `${apiURI}/app-specific/check-app-ajax-auth.php`,
            {
                method: 'POST',
                redirect: 'follow',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    Authorization: `Bearer ${jwtAuthToken}`,
                },
                body: JSON.stringify(postData),
            }
        );
        const results = await response.json();

        console.log('checkcurrent session token valid results:', results);

        // did we get a successful response
        if (response.ok) {
            console.log('verify response:', response);
            // verfiy a successful authorization
            if (!results.success) {
                return rejectWithValue(results.message);
            }

            returnObj = {
                sessionToken: sessionToken,
                jwtAuthToken: jwtAuthToken,
                userId: userId,
            };

            return returnObj;
        } else {
            // return the status text from the response
            Bugsnag.notify('Api Error, check-app-ajax-auth: ' + response.text());
            return rejectWithValue(response.text());
        }
    }
);

/** DEFINE REDUCERS */
export const cbcAuthorizationSlice = createSlice({
    name: 'cbcAuthorization',
    initialState,
    reducers: {
        setGameType(state, {payload}) {
            Bugsnag.leaveBreadcrumb('Action setGameType dispatched');
            state.gameType = payload;
        },
        setAuthLoading(state, {payload}) {
            Bugsnag.leaveBreadcrumb('Action setAuthLoading dispatched');
            state.authLoading = payload.loadingState;
            state.authResultMessage = payload.resultMessage;
        },
        clearState(state) {
            state.userId = 0;
            state.wpAuthorizationToken = '';
            state.apiAuthToken = '';
            state.userType = '';
            state.authLoading = 'idle';
            state.authStatus = 'idle';
            state.authStepStatus = 'pending';
            // SecureStore.deleteItemAsync('username');
            // SecureStore.deleteItemAsync('password');
            SecureStore.deleteItemAsync('apiAuthToken');
            SecureStore.deleteItemAsync('authCode');
            AsyncStorage.removeItem('userId');
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(verifyUserIsLoggedIn.pending, (state) => {
                state.authLoading = 'pending';
                state.authResultMessage = 'Verifying You Are Logged In...';
            })
            .addCase(verifyUserIsLoggedIn.fulfilled, (state, {payload}) => {
                state.authLoading = 'idle';
                state.authResultMessage = '';
                state.userId = payload.userId;
                state.userType = payload.userType;
            })
            .addCase(verifyUserIsLoggedIn.rejected, (state, {payload}) => {
                state.authLoading = 'failed';
                state.authResultMessage = payload;
            })
            .addCase(loginUser.pending, (state) => {
                console.log('loginUser.pending');
                state.authLoading = 'pending';
                state.authStatus = 'pending';
                state.authStepStatus = 'pending';
                state.authResultMessage = 'Logging You In...';
            })
            .addCase(loginUser.fulfilled, (state, {payload}) => {
                console.log('loginUser.fulfilled' , payload.user_id);
                state.authLoading = 'idle';
                state.authResultMessage = '';
                state.userId = payload.user_id;
                state.authStatus = 'pending';
                state.authStepStatus = 'complete';
                state.wpAuthorizationToken = payload.token;
            })
            .addCase(loginUser.rejected, (state, {payload}) => {
                console.log('rejected login')
                state.authLoading = 'failed';
                state.authStatus = 'rejected';
                state.authStepStatus = 'failed';
                state.authResultMessage = payload;
            })
            .addCase(createApiAuthToken.pending, (state) => {
                state.authLoading = 'pending';
                state.authStatus = 'pending';
                state.authStepStatus = 'pending';
                state.authResultMessage = 'Logging You In...';
            })
            .addCase(createApiAuthToken.fulfilled, (state, {payload}) => {
                state.authLoading = 'idle';
                state.authResultMessage = '';
                state.apiAuthToken = payload.authToken;
                state.userType = payload.userType;
                state.authStatus = 'success';
                state.authStepStatus = 'complete';
                console.log('fcreate api auth payload', payload);
            })
            .addCase(createApiAuthToken.rejected, (state, {payload}) => {
                state.authLoading = 'failed';
                state.authStatus = 'failed';
                state.authStepStatus = 'failed';
                state.authResultMessage = payload;
            })
            .addCase(checkCurrentSessionTokenValid.pending, (state) => {
                console.log('checkCurrentSessionTokenValid.pending');
                state.authLoading = 'pending';
                state.authStatus = 'pending';
                state.authStepStatus = 'pending';
                state.authResultMessage = 'Logging You In...';
            })
            .addCase(
                checkCurrentSessionTokenValid.fulfilled,
                (state, {payload}) => {
                    console.log('checkCurrentSessionTokenValid.fulfilled');
                    state.authLoading = 'success';
                    state.authStatus = 'success';
                    state.authStepStatus = 'complete';
                    state.authResultMessage = 'Session Token Validated';
                    state.userId = payload.userId;
                    state.apiAuthToken = payload.sessionToken;
                    state.wpAuthorizationToken = payload.jwtAuthToken;
                }
            )
            .addCase(checkCurrentSessionTokenValid.rejected, (state, {payload}) => {
                console.log('checkCurrentSessionTokenValid.rejected');
                state.authLoading = 'failed';
                state.authStatus = 'failed';
                state.authResultMessage = payload;
            })
            .addCase(logoutUser.fulfilled, (state) => {
                Object.assign(state, initialState);
            });
    },
});

// extract the action creators object and the reducer
const {actions, reducer} = cbcAuthorizationSlice;

export const {setGameType, setAuthLoading, clearState} = actions;

// export the reducer
export default reducer;
